// src/theme/theme.js
import { createSystem, defaultConfig } from "@chakra-ui/react";

const system = createSystem(defaultConfig, {
  theme: {
    tokens: {
      colors: {
        brand: {
          "50": { value: "#e3f2ff" },
          "100": { value: "#b3d4ff" },
          "500": { value: "#3182ce" },
          "700": { value: "#2c5282" },
        },
      },
      fonts: {
        heading: { value: "'Open Sans', sans-serif" },
        body: { value: "'Open Sans', sans-serif" },
      },
    },
    semanticTokens: {
      colors: {
        buttonBg: { value: "black" },
        buttonText: { value: "white" },
        buttonHoverBg: { value: "white" },
        buttonHoverText: { value: "black" },
      },
    },
    components: {
      Button: {
        baseStyle: {
          fontWeight: "medium",
        },
        variants: {
          solid: {
            bg: "buttonBg",
            color: "buttonText",
            _hover: {
              bg: "buttonHoverBg",
              color: "buttonHoverText",
            },
          },
        },
        defaultProps: {
          variant: "solid",
        },
      },
    },
  },
  globalCss: {
    body: {
      background: "white",
      color: "black",
    },
    table: {
      color: "black",
    },
    th: {
      color: "black",
    },
    td: {
      color: "black",
    },
  },
});

export default system;